export const UnitActionTypes = {
    UNIT_DATA_FIRST: '@@auth/UNIT_DATA_FIRST',
    UNIT_DATA_LOADING: '@@auth/UNIT_DATA_LOADING',
    UNIT_DATA_SUCCESS: '@@auth/UNIT_DATA_SUCCESS',
    UNIT_DATA_ERROR: '@@auth/UNIT_DATA_ERROR',

    CREATE_UNIT_DATA_FIRST: '@@auth/CREATE_UNIT_DATA_FIRST',
    CREATE_UNIT_DATA_LOADING: '@@auth/CREATE_UNIT_DATA_LOADING',
    CREATE_UNIT_DATA_SUCCESS: '@@auth/CREATE_UNIT_DATA_SUCCESS',
    CREATE_UNIT_DATA_ERROR: '@@auth/CREATE_UNIT_DATA_ERROR',

    UPDATE_UNIT_DATA_FIRST: '@@auth/UPDATE_UNIT_DATA_FIRST',
    UPDATE_UNIT_DATA_LOADING: '@@auth/UPDATE_UNIT_DATA_LOADING',
    UPDATE_UNIT_DATA_SUCCESS: '@@auth/UPDATE_UNIT_DATA_SUCCESS',
    UPDATE_UNIT_DATA_RESET: '@@auth/UPDATE_UNIT_DATA_RESET',
    UPDATE_UNIT_DATA_ERROR: '@@auth/UPDATE_UNIT_DATA_ERROR',

    DELETE_UNIT_DATA_FIRST: '@@auth/DELETE_UNIT_DATA_FIRST',
    DELETE_UNIT_DATA_LOADING: '@@auth/DELETE_UNIT_DATA_LOADING',
    DELETE_UNIT_DATA_SUCCESS: '@@auth/DELETE_UNIT_DATA_SUCCESS',
    DELETE_UNIT_DATA_RESET: '@@auth/DELETE_UNIT_DATA_RESET',
    DELETE_UNIT_DATA_ERROR: '@@auth/DELETE_UNIT_DATA_ERROR',

    UPLOAD_UNIT_DATA_FIRST: '@@auth/UPLOAD_UNIT_DATA_FIRST',
    UPLOAD_UNIT_DATA_LOADING: '@@auth/UPLOAD_UNIT_DATA_LOADING',
    UPLOAD_UNIT_DATA_SUCCESS: '@@auth/UPLOAD_UNIT_DATA_SUCCESS',
    UPLOAD_UNIT_DATA_RESET: '@@auth/UPLOAD_UNIT_DATA_RESET',
    UPLOAD_UNIT_DATA_ERROR: '@@auth/UPLOAD_UNIT_DATA_ERROR',

    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',

};
